module.exports = __webpack_public_path__ + "static/media/web-24px.e5fe9afe.svg";